<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div class="panel-move">
    <div class="panel-move-box">
      <div v-if="typeof userCount === 'number'" class="panel-move-num">
        {{ userCount | numberSeparator }}
      </div>
      <div v-if="typeof userCount === 'string'" class="panel-move-num">
        {{ userCount }}<span v-if="stringCount">{{ '：' + stringCount }}</span>
      </div>
      <div class="panel-move-equipment" v-if="userPro !== '--'">
        <i class="iconfont" :class="Number(userPro) !== 0 ? (userPro > 0 ?'icon-rise' : 'icon-drop'): 'icon-equal'"></i>
        <span class="panel-move-equ">{{ userPro }}%</span>
      </div>
    </div>

    <div class="panel-move-name">
      <Tooltip v-if="tooltipContent">
        {{ tooltipTitle }}
        <div slot="content">
          {{ tooltipContent }}
        </div>
      </Tooltip>
      <h4 v-else>{{ tooltipTitle }}</h4>
    </div>
  </div>
</template>
<script>
  import numberSeparator from '../../filters/number-separator';

  export default {
    props: {
      userCount: {
        type: String / Number,
        default: '--',
      },
      stringCount: {
        type: String,
        default: '',
      },
      userPro: {
        type: String / Number,
        default: '--',
      },
      tooltipTitle: {
        type: String,
        default: '--',
      },
      tooltipContent: {
        type: String,
        default: '',
      },
    },
    data() {
      return {};
    },
    filters: {
      numberSeparator,
    },
  };
</script>
